import { Component } from '@angular/core';

@Component({
  selector: 'app-error',
  templateUrl: './app.error.component.html',
  standalone :false
})
export class AppErrorComponent {

}
